import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import React, { useEffect, useState } from "react";
import parse from "html-react-parser";

import "swiper/css";
import CheapestCarCard from "@/components/airport/cheapest-cars/CheapestCarCard";

type Props = {
  agency?: Agency;
  carData: CarData[];
  locationName: string;
  updatedAt: string;
  title?: string;
  subtitle?: string;
};

const BestCarsList = (props: Props) => {
  const [isUserAgentBot, setIsUserAgentBot] = useState(true);
  useEffect(() => {
    if (!/bot/i.test(navigator.userAgent)) setIsUserAgentBot(false);
  }, []);
  const policies = [
    {
      value: "CANCEL",
      valueDisplay: "Free cancellation",
    },
    {
      value: "FUEL",
      valueDisplay: "Fair fuel policy",
    },
    {
      value: "MILEAGE",
      valueDisplay: "Unlimited mileage",
    },
  ];
  const now = new Date();
  const updatedAt = props.updatedAt ? new Date(props.updatedAt) : now;
  const timeDiff = Math.floor((now.getTime() - updatedAt.getTime()) / 1000);
  const minutes = Math.floor(timeDiff / 60);
  const hours = Math.floor(minutes / 60);

  const updatedAtString =
    timeDiff === 0
      ? " Just Now"
      : timeDiff > 86400
      ? " 23 hours ago"
      : ` ${hours > 0 ? `${hours} Hours and` : ""} ${
          minutes - hours * 60
        } Minute${minutes === 1 ? "" : "s"} ago`;

  const populatePolicies = (policyArray: number[]) => {
    const policyArr: any = [];
    policyArray?.map((policy: number) => {
      if (policy >= 3) return;
      policyArr.push(policies[policy]);
    });
    return policyArr;
  };
  const handleViewAll = () => {
    document.getElementById("search_button")?.click();
  };
  SwiperCore.use([Autoplay]);

  const dynamicContent = `${props.agency?.name} has one of the best rental car fleets in ${props.locationName}. They have a wide range of cars. Whether traveling to ${props.locationName} for a corporate trip or leisure, for yourself or your whole family, you can find a perfect car with ${props.agency?.name}.`;

  return (
    <div className="mt-5 lg:mt-[60px] bg-white py-[30px]">
      <div className="mx-auto max-w-7xl">
        <div className="w-full px-[16px]">
          <div className=" mb-[18px] flex justify-between items-center">
            <h2 className="text-base font-extrabold lg:text-3xl text-my-dark-blue">
              {props.title
                ? props.title
                : `Best deals for ${props.agency?.name} cars to rent at ${props.locationName}`}
            </h2>
            <p
              onClick={handleViewAll}
              className="cursor-pointer hover:underline hidden md:inline text-[#004DE3] lg:text-base text-sm whitespace-nowrap"
            >
              View All
            </p>
          </div>
          <div className="pb-8 space-y-6 text-sm font-normal lg:pb-0 text-my-light-blue lg:font-light lg:text-base">
            {props.subtitle ? props.subtitle : dynamicContent}
          </div>
        </div>
        <div>
          {isUserAgentBot && (
            <table className="w-full my-8">
              <caption>
                {props.title
                  ? props.title
                  : `Best deals for ${props.agency?.name} cars to rent at ${props.locationName}`}
              </caption>
              <tr>
                <th>Car Name</th>
                <th>Car Class</th>
                <th>Car Features</th>
                <th>Car Agency</th>
                <th>Car Policies</th>
                <th>Car Price</th>
                {/* <th>Book</th> */}
              </tr>
              {props.carData.slice(0, 4).map((data: CarData) => {
                const features = [
                  data.car.luggage && `Luggage ${data.car.luggage}`,
                  data.car.passengers && `Passengers ${data.car.passengers}`,
                  data.car.airconditioning && `Air Conditioning`,
                  data.car.doors && `Doors ${data.car.doors}`,
                ].filter((a) => a !== undefined);
                return (
                  <tr key={data.id}>
                    <td>{data.car.brand}</td>
                    <td>{data.car.carclass}</td>
                    <td>{features.join(", ")}</td>
                    <td>{data.agency.name}</td>
                    <td>
                      {populatePolicies(data.filter.policies)
                        .map((a: any) => a.valueDisplay)
                        .join(",")}
                    </td>
                    <td>{data.displayTotalPrice || data.displayFullPrice}</td>
                    {/* <td>{data.shareURL}</td> */}
                  </tr>
                );
              })}
            </table>
          )}
          {!isUserAgentBot && (
            <>
              <div
                className={`mt-[18px] px-[16px] lg:mt-[40px] lg:grid 
                  md:grid-cols-2
               gap-3 hidden`}
              >
                {props.carData.slice(0, 4).map((data: any) => {
                  let total = 0;
                  data.providers.forEach((provider: any) => {
                    let price = provider.totalPrice;
                    total += price;
                  });
                  return (
                    <CheapestCarCard
                      fuel={data.fuel}
                      prepaid={data.isPrepaid}
                      key={data.id}
                      category={data.car.category}
                      carImg={data.car.thumb}
                      luggage={data.car.luggage}
                      size={data?.car?.carclass}
                      name={data.car.brand}
                      passengers={data.car.passengers}
                      doors={data.car.doors}
                      cost={data.displayTotalPrice || data.displayFullPrice}
                      airconditioning={data.car.airconditioning}
                      data={data}
                      providerLogo={data.providers[0].logoUrl}
                      totalPrice={Math.ceil(total)}
                      sites={data.providers.length}
                      bookUrl={
                        // results===null || !results ?
                        data.shareURL
                        //  : data.providers[0].url
                      }
                      policies={populatePolicies(data.filter.policies)}
                    />
                  );
                })}
              </div>
              <div className="grid lg:hidden">
                <Swiper
                  slidesPerView={1.1}
                  spaceBetween={16}
                  modules={[Autoplay, Pagination]}
                  autoplay
                  pagination={{ clickable: true }}
                  className="w-full h-full mySwiper"
                >
                  {props.carData.slice(0, 4).map((data: any) => {
                    let total = 0;
                    data.providers.forEach((provider: any) => {
                      let price = provider.totalPrice;

                      total += price;
                    });

                    return (
                      <SwiperSlide key={data.id} className="w-full rounded-2xl">
                        <CheapestCarCard
                          fuel={data.fuel}
                          prepaid={data.isPrepaid}
                          key={data.id}
                          category={data.car.category}
                          carImg={data.car.thumb}
                          luggage={data.car.luggage}
                          size={data?.car?.carclass}
                          name={data.car.brand}
                          passengers={data.car.passengers}
                          doors={data.car.doors}
                          cost={data.displayTotalPrice || data.displayFullPrice}
                          airconditioning={data.car.airconditioning}
                          data={data}
                          providerLogo={data.providers[0].logoUrl}
                          totalPrice={Math.ceil(total)}
                          sites={data.providers.length}
                          bookUrl={data.shareURL}
                          policies={populatePolicies(data.filter.policies)}
                        />
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            </>
          )}
        </div>
        <p className="p-4 pb-0 text-sm italic text-[#595959]">
          Last Updated:{updatedAtString}
        </p>
      </div>
    </div>
  );
};

export default BestCarsList;
